import React from 'react';
import { Text } from './Text';
export const Header = ({ size, className, children }) => {
    return (React.createElement(Text, { level: size === 'lg' ? '7' : '6', fontWeight: 'bold', className: `cb-header${className ? ` ${className}` : ''}` }, children));
};
